export const getInitialMinBookingTime = (value) => {
  if (value === 0) return value
  const timeInMinutes = value / 60

  if (timeInMinutes % 60 !== 0) {
    return value / 60
  }

  if ((timeInMinutes / 60) % 24 !== 0) {
    return value / 60 / 60
  }

  return value / 60 / 60 / 24
}
